"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppList = getAppList;
var _request = _interopRequireDefault(require("@/utils/request"));
// 基础模块功能接口

function getAppList(params) {
  return (0, _request.default)({
    url: '/api/v1/app/list',
    method: 'get',
    params: params
  });
}